import { IGroupTaskResource } from "../../group-tasks";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";

export type IGroupTaskDeleteMutationParameters = {
    task: RelationalValue<IGroupTaskResource>;
};

export type IGroupTaskDeleteMutationResult = void;

export const groupTaskDeleteMutation: IApiMutationFunction<IGroupTaskDeleteMutationParameters> = ({ task }) => ({
    method: "DELETE",
    url: `/group_tasks/${mapRelationalValue(task)}`,
});

export const useGroupTaskDeleteMutation = createApiMutationHook<
    IGroupTaskDeleteMutationParameters,
    IGroupTaskDeleteMutationResult
>(groupTaskDeleteMutation);
